var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.customers,"value":_vm.value,"label":_vm.label,"rules":_vm.rules,"return-object":"","outlined":""},on:{"change":_vm.handleCustomerSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }